<template>
  <div class="background">
    <div class="chart-container" id="container">
      <div @click="printPdf" class="noPrint">{{$t('print')}}</div>
      <div class="Hcp-main-header">
        <div class="main-header-left">
          <img src="../../assets/LOGO.png">
        </div>
        <div class="main-header-right">
          <p>{{$t('dboard_report')}}</p>
          <p style="font-size: 13px;">{{$t('date')}}:{{time}}</p>
        </div>
      </div>
      <table class="status-table1" :class="{'zh1':!isEn,'de1':isDe||isIt}">
        <tr>
          <td class="td1 td2">{{$t('uername')}}</td><td colspan="4" class="td2">{{statics.username}}</td>
          <td class="td1 td2">{{$t('fullName')}}</td><td colspan="4" class="td3">{{statics.name}}</td>
        </tr>
        <tr>
          <td rowspan="3" class="td1 td2">{{$t('devices')}}</td>
          <td class="td2" id="reportPdmTitle">{{$t('pdm')}}</td><td colspan="8" class="td3">{{devices[0]}}</td>
        </tr>
        <tr><td class="td2">{{$t('tran')}}</td><td colspan="8" class="td3">{{devices[1]}}</td></tr>
        <tr><td class="td2">{{$t('pumpBase')}}</td><td colspan="8" class="td3">{{devices[2]}}</td></tr>
        <tr>
          <td class="td1 td4">{{$t('disType')}}</td><td colspan="9" class="td4">{{statics.medical_history}}</td>
          <!--<td class="td td4">{{$t('HbA1c')}}</td><td colspan="4">{{hb1c[0]}}</td>-->
        </tr>
      </table>
      <div class="small-hr"></div>

      <div>
        <p style="width: 94%;margin:10px auto;">{{$t("dboard_glucose_statistics")}}</p>
        <table class="statics-table">
          <tr>
            <td colspan="2" class="rb bb">{{$t('dboard_glucose')}}</td>
            <td colspan="2" class="rb bb">{{$t('dboard_cgm')}}</td>
            <td colspan="2" class="rb bb">{{$t('dboard_insulin')}}</td>
            <td colspan="2" class="rb bb">{{$t('dboard_carbs')}}</td>
            <td colspan="2" class="bb">{{$t('dboard_exercise')}}</td>
          </tr>
          <tr class="trh1">
            <td colspan="2" class="rb ">{{$t('dboard_glucose_avg')}}</td>
            <td colspan="2" class="rb ">{{$t('dboard_cgm_avg')}}</td>
            <td colspan="2" class="rb ">{{$t('dboard_insulin_avg')}}</td>
            <td colspan="2" class="rb ">{{$t('dboard_carbs_avg')}}</td>
            <td colspan="2" class="">{{$t('dboard_exercise_avg')}}</td>
          </tr>
          <tr class="trh1">
            <td colspan="2" class="rb bb sp"><span class="bbv">{{bgAvg}}</span> {{glucoseUnit}}</td>
            <td colspan="2" class="rb bb"><span class="bbv">{{sgAvg}}</span> {{glucoseUnit}}</td>
            <td colspan="2" class="rb bb"><span class="bbv">{{insAvg}}</span> {{$t('ins_unit2')}}</td>
            <td colspan="2" class="rb bb"><span class="bbv">{{carbAvg}}</span> g</td>
            <td v-if="exerAvgHour==0" colspan="2" class="bb"><span class="bbv">{{exerAvg}}</span>{{$t('t1112_min')}}</td>
            <td v-else colspan="2" class="bb"><span class="bbv">{{exerAvgHour}}</span>{{$t('Hours')}}  &nbsp;<span class="bbv">{{exerAvg}}</span> {{$t('t1112_min')}}</td>
          </tr>
          <tr >
            <td class="rb bb">{{$t('dboard_sd')}}</td>
            <td class="rb bb">{{$t('dboard_num')}}</td>
            <td class="rb bb">{{$t('dboard_sd')}}</td>
            <td class="rb bb">{{$t('dboard_num')}}</td>
            <td class="rb bb">{{$t('dboard_sd')}}</td>
            <td class="rb bb">{{$t('t1112_days')}}</td>
            <td class="rb bb">{{$t('dboard_sd')}}</td>
            <td class="rb bb">{{$t('dboard_num')}}</td>
            <td class="rb bb">{{$t('dboard_sd')}}</td>
            <td class="bb">{{$t('dboard_num')}}</td>
          </tr>
          <tr>
            <td class="rb">{{bgSD}}</td>
            <td class="rb">{{bgNum}}</td>
            <td class="rb">{{sgSD}}</td>
            <td class="rb">{{sgNum}}</td>
            <td class="rb">{{insSD}}</td>
            <td class="rb">{{insNum}}</td>
            <td class="rb">{{carbSD}}</td>
            <td class="rb">{{carbNum}}</td>
            <td class="rb">{{exerSD}}</td>
            <td class="">{{exerNum}}</td>
          </tr>
        </table>
      </div>

      <div id="est-a1c">
        <div class="left"><span class="est-title">{{$t("est_a1c_t1")}}</span>
          <span v-if="a1c_available"><span>{{est_a1c}} &nbsp;</span><span>{{$t("est_a1c_t2")}}</span>
          </span>
          <span v-else><span>{{$t('t1112_Not_available')}}</span>
          </span>
        </div>

        <div class="right"><span class="x_est-ita">{{$t("est_a1c_t3")}}</span></div>
        <div style="clear: both"></div>
      </div>

      <el-col :span="24">
        <div id="chart1_4" class="graph2"><img id="img1_1" class="img"></div>
      </el-col>

      <el-col :span="24">
        <div class="row1">
          <div class="left-table">
            <p style="margin-left:10px;">{{$t('dboard_statistics')}}</p>
            <table class="statics-table">
              <tr>
                <td class="bb rb" width="20%">{{$t('dboard_BG')}}</td>
                <td class="bb rb" width="50%">{{$t('dboard_BG_calibration')}}</td>
                <td class="bb">{{bgPerDay}} / {{calibPerDay}}</td>
              </tr>
              <tr>
                <td class="rb">{{$t('dboard_SG')}}</td>
                <td class="rb">{{$t('dboard_AUC_high')}} {{highLevelText}}</td>
                <td class="">{{aucu}}</td>
              </tr>
              <tr>
                <td class="rb"></td>
                <td class="rb">{{$t('dboard_AUC_low')}} {{lowLevelText}}</td>
                <td class="">{{aucl}}</td>
              </tr>
              <tr>
                <td class="rb"></td>
                <td class="rb">{{$t('dboard_highest_value')}}</td>
                <td class="">{{sgHighest}}</td>
              </tr>
              <tr>
                <td class="rb"></td>
                <td class="rb">{{$t('dboard_lowest_value')}}</td>
                <td class="">{{sgLowest}}</td>
              </tr>
            </table>

            <table class="statics-table">
              <!--<tr>
                <td class="rb" width="20%">{{$t('dboard_pump')}}</td>
                <td class="rb bb" width="50%">{{$t('dboard_avg_daily_dose')}}</td>
                <td class="bb">{{insAvg}}</td>
              </tr>
              <tr>
                <td class="rb"></td>
                <td class="rb bb">{{$t('dboard_SD')}}</td>
                <td class="bb">{{insSD}}</td>
              </tr>-->
              <tr>
                <td class="rb" width="20%">{{$t('dboard_pump')}}</td>
                <td class="rb bb">{{$t('dboard_daily_basal')}}</td>
                <td class="bb">{{basalPercent}}</td>
              </tr>
              <tr>
                <td class="rb"></td>
                <td class="rb bb">{{$t('dboard_daily_bolus')}}</td>
                <td class="bb">{{bolusPercent}}</td>
              </tr>
              <tr>
                <td class="rb"></td>
                <td class="rb bb">{{$t('dboard_avg_bolus_num')}}</td>
                <td class="bb">{{avgBolusNum}}</td>
              </tr>
              <tr>
                <td class="rb"></td>
                <td class="rb bb">{{$t('dboard_avg_suspend_time')}}</td>
                <td class="bb">{{avgSuspendTime}}</td>
              </tr>
              <tr>
                <td class="rb"></td>
                <td class="rb">{{$t('dboard_avg_reservoir_usage')}}</td>
                <td class="">{{patchAvgLife}} {{$t('t1113_days')}}</td>
              </tr>

            </table>
          </div>

          <div class="right-chart">
            <div id="chart1_5">
              <img id="img1_2" class="img" :class="{'hide':chart5NoData}">
              <p :class="{'hide':chart5NoData}" class="chart_title">Overall: Time In Range</p>
              <p :class="{'hide':!chart5NoData}" id="chart1_5_no_data">No data</p>
            </div>
          </div>
        </div>
      </el-col>

      <div class="page-break"></div>

      <el-col :span="24" style="margin-top:50px;">
        <div class="row2 left-table">
          <table class="statics-table">
            <tr>
              <td class="rb bb" width="65%">{{$t('dboard_manual_bolus')}}</td>
              <td class="bb">{{avgManualBolus}}</td>
            </tr>
            <tr>
              <td class="rb bb" width="65%">{{$t('dboard_normal')}}</td>
              <td class="bb">{{avgManualNormalBolus}}</td>
            </tr>
            <tr>
              <td class="rb bb" width="65%">{{$t('dboard_extend')}}</td>
              <td class="bb">{{avgManualExtendBolus}}</td>
            </tr>
            <tr>
              <td class="rb" width="65%">{{$t('dboard_combo')}}</td>
              <td class="">{{avgManualComboBolus}}</td>
            </tr>
          </table>
          <table class="statics-table">
            <tr>
              <td class="rb bb" width="65%">{{$t('dboard_bolus_calculator')}}</td>
              <td class="bb">{{avgWizzardBolus}}</td>
            </tr>
            <tr>
              <td class="rb bb" width="65%">{{$t('dboard_food_bolus')}}</td>
              <td class="bb">{{avgFoodWizzardBolus}}</td>
            </tr>
            <tr>
              <td class="rb" width="65%">{{$t('dboard_corr_bolus')}}</td>
              <td class="">{{avgCorrWizzardBolus}}</td>
            </tr>
            <!-- 123 -->
            <tr>
              <td class="rb bb" width="65%">{{$t('dboard_override_add')}}</td>
              <td class="bb">{{avgWizzardOverrideAdd}}</td>
            </tr>
            <tr>
              <td class="rb" width="65%">{{$t('dboard_override_sub')}}</td>
              <td class="">{{avgWizzardOverrideSub}}</td>
            </tr>
          </table>
        </div>

        <!--<div class="row2 mid-table">
          <div>

          </div>
        </div>-->

        <div class="row2 right-chart" id="chart1_6">
          <img id="img1_3" class="img" :class="{'hide':chart6NoData}">
          <p :class="{'hide':chart6NoData}" class="chart_title">&nbsp;Basal & Bolus</p>
          <p :class="{'hide':!chart6NoData}" id="chart1_6_no_data">No data</p>
        </div>
      </el-col>

      <!-- 自动模式统计 -->
      <el-col :span="24">
        <div class="row1">
          <div class="left-table">
            <!--            <p>{{$t('dboard_statistics')}}</p>-->
            <table class="statics-table">
              <tr>
                <td class=" rb" width="20%">{{$t('t1221_Auto_Mode')}}</td>
                <td class="bb rb" width="50%">{{$t('t1221_Time_in_Auto_Mode')}}</td>
                <td class="bb">{{timeInAutoMode}}</td>
              </tr>
              <tr>
                <td class=" rb" width="20%"></td>
                <td class="bb rb" width="50%">{{$t('t1221_Average_SG_SD')}}</td>
                <td class="bb">{{autoModeSGAvgSD}} {{glucoseUnit}}</td>
              </tr>
              <tr>
                <td class=" rb" width="20%"></td>
                <td class="bb rb" width="50%">{{$t('t1221_Time_in_Target_Range')}}</td>
                <td class="bb">{{autoModeSGInTargetRange}}</td>
              </tr>
              <tr>
                <td class=" rb" width="20%"></td>
                <td class="bb rb" width="50%">{{$t('t1221_Time_above_Range')}}</td>
                <td class="bb">{{autoModeSGAboveRange}}</td>
              </tr>
              <tr>
                <td class=" rb" width="20%"></td>
                <td class="bb rb" width="50%">{{$t('t1221_Time_below_Range')}}</td>
                <td class="bb">{{autoModeSGBelowRange}}</td>
              </tr>
              <tr>
                <td class=" rb" width="20%"></td>
                <td class="bb rb" width="50%">{{$t('t1221_Auto_Basal_per_day')}}</td>
                <td class="bb">{{autoModeBasalPerDay}}</td>
              </tr>
              <tr>
                <td class="bb rb" width="20%"></td>
                <td class="bb rb" width="50%">{{$t('t1221_Auto_Bolus_per_day')}}</td>
                <td class="bb">{{autoModeBolusPerDay}}</td>
              </tr>
              <tr>
                <td class="rb">{{$t('t1221_Auto_Mode_Exits')}}</td>
                <td class="rb">{{$t('t1221_No_Sensor_readings')}}</td>
                <td class="">{{autoModeExitCauseNoSensorReadings}}</td>
              </tr>
              <tr>
                <td class="rb"></td>
                <td class="rb">{{$t('t1221_Max_Delivery')}} </td>
                <td class="">{{autoModeExitCauseMaxDelivery}}</td>
              </tr>
              <tr>
                <td class="rb"></td>
                <td class="rb">{{$t('t1221_Min_Delivery')}}</td>
                <td class="">{{autoModeExitCauseMinDelivery}}</td>
              </tr>

            </table>


          </div>

          <div class="right-chart">
<!--            <div id="chart1_7" :class="{'hide':chart7NoData}"></div>-->
            <img id="img1_4" class="img" :class="{'hide':chart7NoData}">
            <p class="chart_title" :class="{'hide':chart7NoData}">&nbsp;Auto Mode: Time In Range</p>

            <p :class="{'hide':!chart7NoData}" id="chart1_7_no_data">No data</p>
          </div>
        </div>
      </el-col>


      <!--<br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>-->
      <div class="page-end"></div>
      <!--<div id="est-a1c">
        <div><span class="est-title">{{$t("est_a1c_t1")}} {{est_a1c}} &nbsp;</span><span>{{$t("est_a1c_t2")}}</span></div>
        <div><span class="x_est-ita">{{$t("est_a1c_t3")}}</span></div>
      </div>

      <img id="img1_1" class="img">
      <table class="sgTable">
        <tr>
          <td class="td2 td5">{{$t('Avg Glucose')}}<br>{{unit}}</td> <td class="td2">{{$t('Below ')}}{{hypo}}{{unit}}</td><td class="td2 td6">{{$t('low')}}</td><td class="td2">{{$t('In Target Range')}}<br>{{target}}</td>
          <td class="td2 td6">{{$t('high')}}</td><td class="td2">{{$t('Coefficient of variation')}} </td><td class="td2 td6">{{$t('SD')}}<br> {{unit}}</td><td class="td3">{{$t('% Time CGM Active')}}</td>
        </tr>
        <tr>
          <td class="td4">{{avg}}</td><td v-for="item in seg" class="td4">{{item}}</td>
          <td class="td4">{{cv}}</td><td class="td4">{{sd}}</td><td>{{active}}</td>
        </tr>
      </table>
      <div class="bolCount">
        <p>{{$t('# of Boluses')}}</p>
        <table class="countLabel">
          <tr id="count">
            <td v-for="i in 48"></td>
          </tr>
        </table>
      </div>
      <img id="img1_3" class="img">
      <img id="img1_2" class="img">-->
    </div>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  import auth from '../../auth/auth'
  import B64 from '../../auth/base64'
  export default {
    data() {
      return {
        uid:0, et:0,st:0, time:'',isEn:false,foodCoor:'',unit:'',isMg:'',glucoseUnit:'',ts:[],hypo:3.1,high:10.0,low:5.6,isDe:false,isIt:false,
        statics:{},devices:['--','--','--'],hb1c:['--'],target:'',avg:'--',active:'--',seg : ['--','--','--','--'],sd:'--',cv:'--',
        //est_a1c:'--',

        bgAvg:'--',
        bgSD:'--',
        bgNum:'--',

        sgAvg:'--',
        sgSD:'--',
        sgNum:'--',

        insAvg:'--', insSD:'--', insNum:'--',
        carbAvg:'--', carbSD:'--', carbNum:'--',
        exerAvg:'--', exerSD:'--', exerNum:'--',

        est_a1c:'--',
        a1c_available:false,

        calibPerDay:'--',
        bgPerDay:'--',

        highLevelText:'--',
        lowLevelText:'--',

        aucu:'--',
        aucl:'--',

        sgHighest:'--',
        sgLowest:'--',

        sgDistPie:{},
        sgDistPieLabels:['--', '--', '--', '--'],

        insPieData:[],

        basalPercent:'--',
        bolusPercent:'--',
        avgBolusNum:'--',
        avgSuspendTime:'--',

        avgManualBolus:'--',
        avgManualNormalBolus:'--',
        avgManualExtendBolus:'--',
        avgManualComboBolus:'--',

        avgWizzardBolus:'--',
        avgFoodWizzardBolus:'--',
        avgCorrWizzardBolus:'--',
        avgWizzardOverrideAdd:'--',
        avgWizzardOverrideSub:'--',

        chart5NoData:false,
        chart6NoData:false,
      }
    },
    methods: {
      getStatics(param){
        this.$http.get('api/v2.1/report/'+this.uid+'/data/sa',{params:{param}}).then(function (res) {
          let err =res.body.error;
          //console.log(res);
          if(err === 0){
            let data =  res.data.data;
            data.medical_history = (data.medical_history )?this.$t(data.medical_history):"--";
            this.statics = data;
            this.devices = (data.devices)?data.devices:this.devices;
            if ('EasyPatch'==this.devices[0]) {
              document.getElementById('reportPdmTitle').innerHTML='APP';
            }
            this.hb1c = (data.hba1cList)?data.hba1cList:this.hb1c;
            setTimeout(auth._printPdf(),2000);
          }
        },function(err){
          let tip =  this.$t('tryAgain');
          this.$message.error(tip);
        })
      },
      analySg(){
        let sg = JSON.parse(sessionStorage.getItem('sg7')),validSg =[],totalCount =0,that =this;
        //找出有效sg
        sg.map(function (e,i) {
            let length = e.length;
            if(length>0){
              totalCount += length;
              e.map(function (e1,i1) {
                if(e1[4]==='C'||e1[4]==='NC'){
                  e1[3] = (e1[3]>22.2)?22.2:e1[3];
                  e1[3] = (e1[3]<2.2)?2.2:e1[3];
                  validSg.push(e1[3]);
                }
              })
            }
        });
        let length1 = validSg.length;
        if(totalCount>0&&length1>0){
          let totalSg = 0,Seg=[0,0,0,0];
          let high = (this.isMg)?parseFloat((this.high/18).toFixed(1)):this.high;
          let low = (this.isMg)?parseFloat((this.low/18).toFixed(1)):this.low;
          this.active = ((length1/totalCount)*100).toFixed(1)+' %';
          validSg.map(function (e,i) {
            totalSg +=e;
            if(e<3.1){Seg[0]++;}
            else if(e<low){Seg[1]++;}
            else if(e<high){Seg[2]++;}
            else{Seg[3]++;}
          });
          let avg = totalSg/length1;
          this.avg = (this.isMg)?Math.round(avg*18):avg.toFixed(1);
          this.est_a1c =  (((avg*18)+46.7) / 28.7).toFixed(1) + '%';
          console.log('a1c_available:', sg.length, totalCount);
          if (totalCount>sg.length*720*0.8) {
            this.a1c_available=true;
          }
          //计算分段比例
          Seg.map(function (e,i) {
            let scale = ((e/length1)*100).toFixed(1);
            that.seg[i] = scale + ' %';
          });
          //计算sd与cv
          let tran = 0;
          validSg.map(function (e,i) {
            let d = e-avg;
            tran +=Math.pow(d,2);
          });
         let sd = Math.sqrt(tran/length1);
         this.sd = (this.isMg)?Math.round(sd*18):sd.toFixed(1);
         this.cv = ((sd/avg)*100).toFixed(1)+' %';
        }
      },
      showCount(){
        let count = JSON.parse(sessionStorage.getItem('count7'));
        let length= count.length;
        let tr = document.getElementById('count');
        for(let i=0;i<length;i++){
          let td = tr.getElementsByTagName('td')[count[i][0]];
          td.innerHTML = count[i][1];
        }
      },
      printPdf(){
        auth.print_page();
      },
    },
    mounted: function () {
      self.document.title = this.$t('dboard_report');
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isDe = (lang==='de')?true:false;
      this.isIt = (lang==='it')?true:false;
      this.isMg = (localStorage.getItem('unit')==='mg')?true:false;
      this.glucoseUnit=(this.isMg)?'mg/dL':'mmol/L';
      this.unit = (this.isMg)?' mg/dL':' mmol/L';
      this.hypo = (this.isMg)? 54:3.1;
      let st = sessionStorage.getItem('st7');
      let et = sessionStorage.getItem('et7');
      this.st = parseInt(st);
      this.et =  parseInt(et);
      this.ts = [[this.st,this.et]];
      let param = {
        ts:this.ts,
        tz:parseInt(sessionStorage.getItem('tz')),
        gu:(this.isMg)?'mg/dL':'mmol/L',
      };
      if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }

      param = B64.base64encode(JSON.stringify(param));
      this.getStatics(param);
      this.time =sessionStorage.getItem('timeRange7');
      let img1 = document.getElementById('img1_1');
      img1.src = sessionStorage.getItem('src7_1');
      let img2 = document.getElementById('img1_2');
      img2.src = sessionStorage.getItem('src7_2');
      let img3 = document.getElementById('img1_3');
      img3.src = sessionStorage.getItem('src7_3');
      let img4 = document.getElementById('img1_4');
      img4.src = sessionStorage.getItem('src7_4');
      //console.log('src2:', img2.src)
      let dashboardStatInfo=sessionStorage.getItem('dashboardStatInfo')
      console.log('dashboardStatInfo:', dashboardStatInfo, typeof dashboardStatInfo)
      dashboardStatInfo=JSON.parse(dashboardStatInfo)
      for (let p in dashboardStatInfo) {
        this[p]=dashboardStatInfo[p];
        //console.log(p, this[p], dashboardStatInfo[p])
      }
      //this.bgAvg='231'
      this.high = parseFloat(sessionStorage.getItem('targetH7'));
      this.low = parseFloat(sessionStorage.getItem('targetL7'));
      this.target = '( '+this.low+' - '+this.high+this.unit+' )';
      //this.analySg();
      //this.showCount();
    },
  }
</script>
<style scoped meadia="print">
  @page{
    *size:auto;
    size:portrait;
    margin: 0;
  }
  .background{
    padding-top: 5mm;
    width: 100%;
    *min-height: 377mm;
    background: #ccc;
  }
  .background .noPrint{
    float: left;
    border-radius:100px;
    background: #fff;
    border: 1px solid #a3a3a3;
    outline: none;
    margin-top:4px;
    width:90px;
    height:26px;
    line-height: 28px;
    cursor: pointer;
    margin-left:-140px;
    font-size: 13px;
    text-align: center;
  }
  @media print {
    .background .noPrint{
      display: none;
    }
  }
  .chart-container {
    width:210mm;
    *min-height:377mm;
    font-family:SFUIText-Regular;
    font-size:13px;
    color:#282828;
    letter-spacing:-0.34px;
    background: #fff;
    margin:0 auto;
    padding-left: 20px;
    padding-right: 20px;
  }
  .Hcp-main-header{
    width:97%;
    height:40px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:12px;
    color:#282828;
    padding-top: 10px;
  }
  .main-header-left{
    float: left;
  }
  .main-header-left img{
    height:45px;
    width: 100px;
  }
  .main-header-right{
    float: right;
    text-align: right;
    padding-top: 10px;
    margin-right: 15px;
  }
  .main-header-right p{
    font-size:12px;
    margin-bottom: 5px;
    letter-spacing:-0.29px;
    font-family:SFUIText-Regular;
    color:#282828;
  }


  .status-table1{
    width: 94%;
    margin:20px auto 16px;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    font-size:12px;
    border-collapse: collapse;
    text-align:left;
    table-layout: fixed;
  }
  .status-table1 td{
    padding-left: 8px;
    height:15px;
  }
  .status-table1 .td1{
    width: 14%;
  }
  .zh1 .td1{
    width: 12%;
  }
  .de1 .td1{
    width: 11%;
  }
  .de1 td{
    padding-left: 3px;
  }
  .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .td3{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .td4{
    border-right:1px solid rgba(116,116,116,0.34);
  }

  .small-hr{
    width:94%;
    margin:10px auto 16px;
    border-top:1px solid #3b3b3b;
  }
  /*.img{
    width:97%;
    height:160px;
    margin-left: 2%;
    margin-bottom: 10px;
  }*/
  #img1_1 {
    width:100%;
    *width:92%;
    *float:left;
    *margin:0 auto;
    *margin-left:3%;
  }
  #img1_2 {
    width:98%;
    margin-top:20px;
  }
  #img1_3 {
    margin-top:30px;
    width:100%;
  }
  #img1_4 {
    margin-top:30px;
    width:98%;
  }

  #est-a1c {
    width:90%;
    margin:15px auto;
  }

  #est-a1c div {
   margin-bottom:5px;
  }

  #est-a1c .x_est-title {
    font-size:14px;
    *font-weight:bold;
  }

  #est-a1c .est-ita {
    font-style:italic;
  }

  .sgTable{
    width: 93%;
    margin:5px auto 20px;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:center;
    font-size: 13px;
  }
  .sgTable td{
    height:30px;
  }
  .sgTable .td5{
    width: 12%;
  }
  .sgTable .td6{
    width: 10%;
  }

  .bolCount{
    width:90.5%;
    height:30px;
    clear: both;
    margin:0 auto -22px;
  }
  .bolCount p{
    height: 15px;
  }
  .countLabel{
    width: 96.5%;
    height: 15px;
    margin-left: 1.5%;
    font-family:SFUIText-Regular;
    font-size:12px;
    border-collapse: collapse;
    text-align:center;
    table-layout: fixed;
  }
  .countLabel td{
    border:none;
   * border: 1px solid #ccc;
  }

  .chart-container .graph2{
    width:100%;
    *height:240px;
    height:50mm;
    margin-bottom: 15px;
  }

  .chart-container .graph2 img {
    height: 100%;
    *width: 80%;
  }

  .statics-table{
    width: 94%;
    margin:10px auto 0;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:center;
    table-layout: fixed;
  }

  .statics-table tr{
    height:25px;
  }

  .statics-table .rb{
    border-right:1px solid rgba(116,116,116,0.34);
  }


  .statics-table .bb{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }

  #est-a1c {
    width:94%;
    margin:15px auto;
    margin-top:18px;
    margin-bottom:10px;
    font-size:15px;
  }

  #est-a1c .left {
    float:left;
  }

  #est-a1c .right {
    float:right;
  }

  #est-a1c div {
    margin-bottom:5px;
  }

  #est-a1c .x_est-title {
    *font-size:14px;
    *font-weight:bold;
  }

  #est-a1c .est-ita {
    font-style:italic;
  }

  .chart-container .row1 div{
    float:left;
  }

  .chart-container .row1 .left-table{
    width:40%;
  }

  .chart-container .row1 .right-chart{
    width:60%;
    height:350px;
  }

  #chart1_5 {
    width:90%;
    *height:200px;
    height:98%;
  }

  .chart-container .row2{
    float:left;
  }

  .chart-container .row2.left-table{
    width:40%;
    margin-right:1%;
    *margin-top:100px;
  }

  .chart-container .row2.mid-table{
    width:32%;
    margin-right:1%;
  }

  .chart-container .row2.right-chart{
    width:58%;
    height:250px;
    margin-top:-20px;
  }

  .hide {
    display: none;
  }

  .chart_title {
    float:left;
    width: 90%;
    text-align: center;
    font-size:16px;
    font-weight: bold;
  }

  #chart1_5_no_data {
    text-align: center;
    margin-top:70px;
  }

  #chart1_6_no_data {
    text-align: center;
    margin-top:70px;
  }

  /* big bold value */
  .bbv {
    font-size:24px;
    font-weight: bold;
    margin-right:5px;
    color:#282828;
  }

  /*some padding*/
  .sp {
    padding: 10px;
  }
  .page-break {
    page-break-before: always;
  }
  .page-end {
    clear:both;
    height:10mm;
  }

</style>



// WEBPACK FOOTER //
// chart0_print.vue?3819551e